import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

const REALIZE_COLOR = '#9C27B0';

const WorkInProgressPage = ({ title }) => (
  <Box>
    <Paper sx={{ p: 6, textAlign: 'center' }}>
      <ConstructionIcon sx={{ fontSize: 64, color: REALIZE_COLOR, mb: 2 }} />
      <Typography variant="h5" gutterBottom fontWeight="bold">
        {title || 'Work in Progress'}
      </Typography>
      <Typography color="text.secondary">
        This section is under development and will be available soon.
      </Typography>
    </Paper>
  </Box>
);

export default WorkInProgressPage;
